import { Socket } from 'phoenix'

function Channel(Vue, socket, topic) {
  var self = this;

  self.socket = socket;
  self.channel = undefined;
  self.topic = topic;
  self.data = {}
  self.refs = 0;
  self.callbacks = {};
  self.callbackRef = 0;

  self.__init__ = function(create_on_callbacks) {
    if(!self.channel) {
      self.channel = self.socket.channel(self.topic);

      if(typeof(create_on_callbacks) != "boolean" || create_on_callbacks == true) {
        self.channel.on("init", (msg) => {
          Vue.set(self, "data", msg)
        });

        self.channel.on("update", (msg) => {
          Vue.set(self, "data", msg)
        });

        self.channel.on("data", (msg) => {
          Vue.set(self,"data",msg.data);
        });
      }

    }
  }

  self.on = function(name, cb) {
    if(self.channel) {
      if(!self.callbacks[name]) {
        self.callbacks[name] = [];
        self.channel.on(name, function(...args) {
          _.each(self.callbacks[name], ({callback}) => {
            callback(...args);
          });
        });
      }
      var ref = self.callbackRef++;
      self.callbacks[name].push({callback: cb, ref: ref});
      return ref;
    } else {
      return undefined;
    }
  }

  self.off = function(name, delete_ref) {
    self.callbacks[name] = _.filter(self.callbacks[name], ({ref}) => { return ref != delete_ref; });
  }

  self.join = function(...args) {
    self.refs++;
    if(self.channel && self.refs == 1 && !self.channel.joinedOnce) {
      return self.channel.join(...args);
    } else if (self.channel) {
      return undefined;
    }
    throw "Channel "+self.topic+" not found!";
  }

  self.leave = function(...args) {
    if(self.refs > 0) self.refs--;
    if(self.channel && self.refs == 0) {
      var res = self.channel.leave(...args)
        .receive("ok", () => {
          if(Vue.Socket.channels[self.topic] && self.refs == 0) {
            delete Vue.Socket.channels[self.topic];
          }
        });
      return res;
    } else if(self.channel) {
      return undefined;
    }
    throw "Channel "+self.topic+" not found!";
  }

  self.push = function(...args) {
    if(args[0] == "save") {
      console.warn("Deprecated save. Use channel.save(payload) function.");
    }
    if(self.channel) {
      return self.channel.push(...args);
    }
    throw "Channel "+self.topic+" not found!";
  }

  self.setData = function(msg) {
    if(typeof(msg.data) != "undefined") Vue.set(self,"data",msg.data);
  }

  self.save = function(payload, set_data) {
    return new Promise((resolve, reject) => {
      var push = self.channel.push("save", payload)
      push.receive("ok", (msg) => {
        if(typeof(set_data) == "undefined" || set_data) Vue.set(self,"data",msg.data);
        resolve(msg, push);
      })
      push.receive("error", (msg) => {
        reject({type: "error", msg: msg});
      });
      push.receive("timeout", (msg) => {
        reject({type: "error", msg: msg});
      });
    });
  }

}



export default {
  install(Vue, connection, opts) {
    let socket = new Socket(connection,opts||{});
    let version = "17.12.2025";

    Vue.prototype.$socket = socket;

    Vue.Socket = {
      socket: socket,
      channels: {}
    };
    Vue.Socket.connect = function(params) {
      socket.params = params;
      socket.params.version = version;
      socket.connect();
    }
    Vue.Socket.disconnect = function() {
      socket.disconnect();
    }

    function Cloudserver() {
      var self = this;

      self.channels = {};

      self.channel = function(topic, create_on_callbacks) {
        var ch = Vue.Socket.channels[topic] || new Channel(Vue, socket, topic);
        if (typeof(Vue.Socket.channels[topic]) == "undefined") Vue.Socket.channels[topic] = ch;
        if (typeof(self.channels[topic]) == "undefined") self.channels[topic] = ch;
        ch.__init__(create_on_callbacks);
        return ch;
      }

    }


    let addListeners = function() {
      this.$cloudserver = new Cloudserver();
      if (this.$options["socket"]) {
        let conf = this.$options.socket;
        if(conf.open) {
          let func = conf.open.bind(this);
          Vue.Socket.socket.onOpen(func);
          conf.open.__binded = func;
        }
        if(conf.close) {
          let func = conf.close.bind(this);
          Vue.Socket.socket.onClose(func);
          conf.close.__binded = func;
        }
        if(conf.error) {
          let func = conf.error.bind(this);
          Vue.Socket.socket.onError(func);
          conf.error.__binded = func;
        }
        if(conf.message) {
          let func = conf.message.bind(this);
          Vue.Socket.socket.onMessage(func);
          conf.message.__binded = func;
        }
      }
    }

    let removeListeners = function() {
      if(this.$cloudserver) {
        Object.keys(this.$cloudserver.channels).forEach((ch_name) => {
          this.$cloudserver.channels[ch_name].leave();
          if(this.$cloudserver.channels[ch_name].refs == 0) {
            delete this.$cloudserver.channels[ch_name];
          }
        });
      }
      if (this.$options["socket"]) {
        let conf = this.$options.socket;
        let cbs = Vue.Socket.socket.stateChangeCallbacks;
        if(conf.open) {
          cbs.open = cbs.open.filter(item => item !== conf.open.__binded)
        }
        if(conf.close) {
          cbs.close = cbs.close.filter(item => item !== conf.close.__binded)
        }
        if(conf.error) {
          cbs.error = cbs.error.filter(item => item !== conf.error.__binded)
        }
        if(conf.message) {
          cbs.message = cbs.message.filter(item => item !== conf.message.__binded)
        }

      }
    };

    Vue.mixin({
      beforeCreate: addListeners,
      beforeDestroy: removeListeners
    });
  }
}
